import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchItems = async options => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const fetchCategories = async options => {
  const url = apiConstants.category;
  return await apiGet(url, { params: options });
};

const fetchSuppliers = async options => {
  const url = apiConstants.suppliers;
  return await apiGet(url, { params: options });
};

const duplicateItem = async id => {
  const url = apiConstants.url;
  return await apiPost(url + "/" + id + "/duplicate");
};

export {
  fetchItems,
  saveItem,
  deleteItem,
  fetchItem,
  fetchCategories,
  fetchSuppliers,
  duplicateItem
};
